import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiDownload, FiLock, FiAlertCircle, FiBookOpen, FiCheckCircle } from 'react-icons/fi';
import { motion } from 'framer-motion';

const Playbook = ({ user, onLogout }) => {
  const isGuest = user?.isGuest;
  const pdfUrl = "https://media-manager-c.questera.ai/greta-media/c4cd7048ee42a7b0632cdf5aa1fa307c48d20f8ae20304e7af2c62d9e8bb8b361540d414afb44516657958e65ec582f9/documents/YXBwbGljYXRpb24vcGRm/dbf836a1fb4fed98fbea22213e171e08.pdf";
  const imgUrl = "https://media-manager-c.questera.ai/greta-media/c4cd7048ee42a7b0632cdf5aa1fa307c48d20f8ae20304e7af2c62d9e8bb8b361540d414afb44516657958e65ec582f9/images/aW1hZ2UvcG5n/2b9525b23fd574815eb2dd82a6c304ca.png";

  return (
    <div className="p-4 md:p-8 max-w-5xl mx-auto h-full flex flex-col">
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 md:mb-8 gap-4">
        <div>
          <h1 className="text-xl md:text-2xl font-bold text-slate-800">NetDesk Pro Playbook</h1>
          <p className="text-xs md:text-sm text-slate-500">Official training materials and guides</p>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto hide-scrollbar pb-8">
        <div className="bg-white rounded-[2rem] border border-slate-200 shadow-sm overflow-hidden max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 p-8 md:p-12 items-center">
            <div className="order-2 md:order-1 space-y-6">
              <div className="inline-flex items-center space-x-2 bg-blue-50 text-blue-600 px-3 py-1.5 rounded-lg text-[10px] font-black uppercase tracking-widest">
                <SafeIcon icon={FiBookOpen} />
                <span>Official eBook</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-black text-slate-900 leading-tight">Real-World Help Desk Skills for Beginners</h2>
              <p className="text-slate-600 leading-relaxed text-sm md:text-base">
                A real-world playbook for beginners entering IT support, covering ticket handling, troubleshooting, escalation, documentation, and customer service.
              </p>

              <div className="pt-4 border-t border-slate-100">
                {isGuest ? (
                  <div className="space-y-4 pt-2">
                    <button disabled className="w-full sm:w-auto flex items-center justify-center space-x-2 px-8 py-4 bg-slate-100 text-slate-400 rounded-xl font-black uppercase tracking-widest text-xs cursor-not-allowed">
                      <SafeIcon icon={FiLock} />
                      <span>Member Only Download</span>
                    </button>
                    <div className="flex items-start space-x-3 p-4 bg-amber-50 border border-amber-100 rounded-xl text-amber-700">
                      <SafeIcon icon={FiAlertCircle} className="shrink-0 mt-0.5 text-lg" />
                      <p className="text-xs font-bold leading-relaxed">
                        Guest accounts cannot download premium resources. Please <button onClick={onLogout} className="underline hover:text-amber-900 mx-1">log out and enroll</button> as a Member to access this eBook.
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-4 pt-2">
                    <a href={pdfUrl} target="_blank" rel="noopener noreferrer" download="netdeskpro_ebook.pdf" className="w-full sm:w-auto inline-flex items-center justify-center space-x-2 px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-black uppercase tracking-widest text-xs transition-all shadow-xl shadow-blue-200">
                      <SafeIcon icon={FiDownload} />
                      <span>Download Playbook (PDF)</span>
                    </a>
                    <div className="flex items-center space-x-2 text-emerald-600 text-xs font-bold">
                      <SafeIcon icon={FiCheckCircle} />
                      <span>Access Granted: Member Status Verified</span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="order-1 md:order-2 flex justify-center">
              <motion.img
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.6 }}
                src={imgUrl}
                alt="NetDesk Pro Playbook Cover"
                className="w-full max-w-sm rounded-xl shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500 border border-slate-200"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Playbook;